var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        fullscreen: _vm.$vuetify.breakpoint.smAndDown,
        "content-class": "deliver-dialog",
        "max-width": "600",
        persistent: "",
        lazy: ""
      },
      model: {
        value: _vm.openDialog,
        callback: function($$v) {
          _vm.openDialog = $$v
        },
        expression: "openDialog"
      }
    },
    [
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.currentStep,
            callback: function($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep"
          }
        },
        [
          _c(
            "v-stepper-header",
            [
              _c(
                "v-stepper-step",
                {
                  attrs: {
                    complete: _vm.currentStep > 1 || !_vm.missingBOL,
                    step: "1"
                  }
                },
                [
                  _vm._v(
                    "\n        Attach " +
                      _vm._s(_vm.$t("terms.bill-of-lading")) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-stepper-step",
                { attrs: { complete: _vm.currentStep > 2, step: "2" } },
                [_vm._v("\n        Delivery Information\n      ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-stepper-items",
            [
              _c(
                "v-stepper-content",
                { attrs: { step: "1" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-layout",
                        { staticClass: "px-3", attrs: { column: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs9: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.immediate",
                                        value: {
                                          required: true,
                                          alpha_dash: true
                                        },
                                        expression:
                                          "{ required: true, alpha_dash: true }",
                                        modifiers: { immediate: true }
                                      }
                                    ],
                                    attrs: {
                                      label: _vm.billOfLadingNumberFieldLabel,
                                      "error-messages": _vm.errors.first(
                                        "bolNumber",
                                        "step1"
                                      ),
                                      "data-vv-as":
                                        _vm.billOfLadingNumberFieldLabel,
                                      "data-vv-name": "bolNumber",
                                      "data-vv-scope": "step1"
                                    },
                                    model: {
                                      value: _vm.billOfLadingNumber,
                                      callback: function($$v) {
                                        _vm.billOfLadingNumber = $$v
                                      },
                                      expression: "billOfLadingNumber"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    xs6: _vm.canSkipDeliveryDocuments,
                                    xs12: !_vm.canSkipDeliveryDocuments
                                  }
                                },
                                [
                                  _c("v-list-tile-action-text", [
                                    _vm._v("Attach Delivery Document Photos")
                                  ]),
                                  _vm._v(" "),
                                  _c("files-upload-btn", {
                                    staticClass: "px-5",
                                    attrs: {
                                      "btn-class": "primary mx-0",
                                      "uploading-progress":
                                        _vm.uploadPercentage,
                                      multiple: "",
                                      disabled: _vm.errors.any("step1")
                                    },
                                    on: {
                                      upload: function($event) {
                                        return _vm.uploadBOL($event, true)
                                      },
                                      fileCount: _vm.onFileListChange
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { xs1: "" } }),
                              _vm._v(" "),
                              _vm.canSkipDeliveryDocuments
                                ? _c(
                                    "V-flex",
                                    { attrs: { xs3: "" } },
                                    [
                                      _c(
                                        "v-list-tile-action-text",
                                        { staticClass: "pb-5 mb-5" },
                                        [_vm._v("Or, Skip this right now")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mt-4",
                                          attrs: {
                                            flat: "",
                                            color: "primary",
                                            disabled: _vm.errors.any("step1")
                                          },
                                          on: { click: _vm.skipFileUploads }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("fast_forward")
                                          ]),
                                          _vm._v(
                                            "\n                   Skip\n                "
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", color: "accent" },
                              on: {
                                click: function($event) {
                                  _vm.openDialog = false
                                }
                              }
                            },
                            [_vm._v("\n              Cancel\n            ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-stepper-content",
                { attrs: { step: "2" } },
                [
                  _c(
                    "v-layout",
                    { staticClass: "px-3", attrs: { column: "" } },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "pr-5", attrs: { column: "" } },
                        [
                          _c("v-float-field", {
                            attrs: {
                              label: "Animal Count",
                              "error-messages": _vm.errorMessages
                            },
                            model: {
                              value: _vm.animalCount,
                              callback: function($$v) {
                                _vm.animalCount = $$v
                              },
                              expression: "animalCount"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-float-field", {
                            attrs: { label: _vm.deliveryDialogWeightLabel },
                            model: {
                              value: _vm.animalWeight,
                              callback: function($$v) {
                                _vm.animalWeight = $$v
                              },
                              expression: "animalWeight"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { staticClass: "pr-5", attrs: { column: "" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Trailer Identifier" },
                            model: {
                              value: _vm.trailerIdentifier,
                              callback: function($$v) {
                                _vm.trailerIdentifier = $$v
                              },
                              expression: "trailerIdentifier"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: { label: "Truck Identifier" },
                            model: {
                              value: _vm.truckIdentifier,
                              callback: function($$v) {
                                _vm.truckIdentifier = $$v
                              },
                              expression: "truckIdentifier"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-textarea", {
                            attrs: { label: "Notes" },
                            model: {
                              value: _vm.deliveryNotes,
                              callback: function($$v) {
                                _vm.deliveryNotes = $$v
                              },
                              expression: "deliveryNotes"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.loadingDeliveredBtn,
                        color: "accent",
                        disabled: !_vm.validAnimalCount
                      },
                      on: { click: _vm.setDelivered }
                    },
                    [_vm._v("\n          Delivered\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.openDialog = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22795d5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22795d5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/DeliverLoadDialog.vue
// module id = null
// module chunks = 